module.exports = __webpack_public_path__ + "static/media/water-ski.f1cd51b1.png";